import * as VTable from '@visactor/vtable'
import { aggregationAmount, aggregationSUM, numberStyle } from '@/utils/index'

const fbfx = [
  { field: 'code', title: '编码' },
  { field: 'type', title: '类别' },
  { field: 'projectName', editor: { type: 'textarea' }, title: '项目名称' },
  { field: 'projectDesc', editor: { type: 'textarea' }, title: '项目特征' },
  { field: 'unit', title: '单位' },
  { field: 'quantity', title: '数量' },
  { field: 'rate', title: '单价' },
  { field: 'amount', title: '金额' }
]

const fyhz = [
  { field: 'seqNum', title: '编码' },
  { field: 'projectName', title: '名称' },
  { field: 'baseAmount', title: '取费基数' },
  { field: 'costRatio', title: '费率' },
  { field: 'amount', title: '金额' }
]

const csxm = [
  { field: 'code', title: '编码' },
  { field: 'type', title: '类别' },
  { field: 'projectName', editor: { type: 'textarea' }, title: '项目名称' },
  { field: 'projectDesc', editor: { type: 'textarea' }, title: '项目特征' },
  { field: 'unit', title: '单位' },
  { field: 'quantity', title: '数量' },
  { field: 'rate', title: '单价' },
  { field: 'amount', title: '金额' }
]

const rcj = [
  { field: 'code', title: '编码' },
  { field: 'type', title: '类别' },
  { field: 'name', title: '人材机名称' },
  { field: 'spec', title: '规格型号' },
  { field: 'unit', title: '单位' },
  { field: 'quantity', title: '数量' },
  { field: 'rate', title: '单价' },
  { field: 'amount', title: '金额' }
]

const zjzb = [
  // {
  //   field: 'level1Indicator',
  //   title: '一级指标',
  //   aggregation: aggregationSUM
  // },
  // { field: 'level2Indicator', title: '二级指标' },
  { field: 'level3Indicator', title: '三级指标', aggregation: aggregationSUM },
  { field: 'unit', title: '单位' },
  { field: 'quantity', title: '工程量', ...numberStyle },
  {
    field: 'totalCost',
    title: '总造价',
    aggregation: aggregationAmount,
    ...numberStyle
  },
  { field: 'percentage', title: '占比', ...numberStyle },
  // { field: 'rateIndicator', title: '单价指标' },
  // { field: 'quantityIndicator', title: '工程量指标' },
  {
    field: 'costIndicator',
    title: '单方造价指标',

    aggregation: [
      {
        showOnTop: false,
        aggregationType: VTable.TYPES.AggregationType.NONE,
        showOnTop: false,
        cellType: 'text',
        formatFun(value) {
          // 被组件重写了
        }
      }
    ],
    ...numberStyle
  }
]

const qd = [
  // { field: 'level1Indicator', title: '一级指标', aggregation: aggregationSUM },
  // { field: 'level2Indicator', title: '二级指标' },
  // { field: 'level3Indicator', title: '三级指标' },
  // { field: 'billKeywords', title: '清单关键字' },
  // { field: 'valuationIndicatorCategoryName', title: '计价指标项' },
  { field: 'code', title: '编码' },
  { field: 'type', title: '类别' },
  { field: 'projectName', editor: { type: 'textarea' }, title: '项目名称' },
  { field: 'projectDesc', editor: { type: 'textarea' }, title: '项目特征' },
  { field: 'unit', title: '单位' },
  { field: 'quantity', title: '数量', ...numberStyle },
  { field: 'rate', title: '单价', ...numberStyle },
  {
    field: 'amount',
    title: '金额',
    aggregation: aggregationAmount,
    ...numberStyle
  },
  { field: 'percentage', title: '占比', ...numberStyle },
  {
    field: 'totalCost',
    title: '总造价',
    aggregation: aggregationAmount,
    ...numberStyle
  },
  // {
  //   field: 'otherAmount',
  //   title: '其他费',
  //   aggregation: aggregationAmount,
  //   ...numberStyle
  // },
  // { field: 'quantityIndicator', title: '工程量指标', ...numberStyle },
  // { field: 'costIndicator', title: '造价指标', ...numberStyle },
  { field: 'resourceName', title: '历史材料' },
  { field: 'resourceSpec', title: '历史规格型号' },
  { field: 'resourceRate', title: '历史单价', ...numberStyle }
  // { field: 'keywords', title: '关键词' }
]

const qyde = [
  { field: 'type', title: '类别', aggregation: aggregationSUM },
  { field: 'name', title: '人材机名称' },
  { field: 'spec', title: '规格型号' },
  { field: 'unit', title: '单位' },
  { field: 'quantity', title: '数量', ...numberStyle },
  { field: 'rate', title: '单价', ...numberStyle },
  // { field: 'industryQuotaContent', title: '行业定额含量' },
  // {
  //   field: 'actualQuantity',
  //   title: '实际数量',
  //   fieldFormat: data => {
  //     return data.actualQuantity ? Number(data.actualQuantity) : ''
  //   },
  //   canEdit: true,
  //   canModify: true,
  //   ...numberStyle
  // },
  {
    field: 'amount',
    title: '金额',
    aggregation: aggregationAmount,
    ...numberStyle
  }
  // { field: 'quantityIndicator', title: '消耗量指标', ...numberStyle },
  // { field: 'costIndicator', title: '造价指标', ...numberStyle },
  // // { field: 'enterpriseQuotaContent', title: '企业定额含量' },
  // { field: 'nameKeywords', title: '名称关键词' },
  // { field: 'specKeywords', title: '规格型号关键词' }
]

export { fbfx, fyhz, csxm, rcj, zjzb, qd, qyde }
